import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AppShell from "@/components/AppShell";
import PatientForm, { initialPatient } from "@/components/PatientForm";
import api, { formatApiError } from "@/lib/api";

export default function NewPatient() {
    const [f, setF] = useState(initialPatient);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true); setError(null);
        try {
            const { data } = await api.post("/patients", f);
            navigate(`/patients/${data.id}`);
        } catch (err) { setError(formatApiError(err)); }
        finally { setLoading(false); }
    };

    return (
        <AppShell>
            <button onClick={() => navigate(-1)} className="btn-ghost mb-4"><ArrowLeft size={16} /> Voltar</button>
            <div className="max-w-3xl">
                <h1 className="font-display text-3xl font-medium text-brand mb-1">Novo paciente</h1>
                <p className="text-muted-clinical mb-6">Cadastro inicial. Dados clínicos serão preenchidos na consulta.</p>
                <PatientForm
                    value={f}
                    onChange={setF}
                    onSubmit={submit}
                    loading={loading}
                    error={error}
                    submitLabel="Cadastrar paciente"
                />
            </div>
        </AppShell>
    );
}
